export default __webpack_public_path__ + "Revenue_Calculator_New_Product_Template_FE-zh-TW.905ec305.xlsx";